import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import { Dimensions, PixelRatio } from "react-native";

const { width, height } = Dimensions.get("window");

const initialMultiplier = isWebDesktop ? 0.75 : height < 750 ? 1.8 : 2.4;

const normalize = (size, multiplier = initialMultiplier) => {
  if (isWebDesktop) {
    return size;
  }
  const scale = (width / height) * multiplier;

  const newSize = size * scale;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

export default normalize;
